import React, { useState, useEffect } from 'react';
import './RegulationsPage.scss';
import { AppState } from '../../store/rootReducer';
import { connect, useDispatch } from 'react-redux';
import { RegulationsProps } from './types';
import { Document } from '../../store/documents/types';
import { getDocumentsList } from '../../store/documents/selectors';
import { requestGetDocumentsList } from '../../store/documents/actions';
import DocumentsTypes from '../../resources/enums/DocumentsTypes';
import { Paper } from '@mui/material';

const RegulationsPage: React.FC<RegulationsProps> = (props) => {
    const dispatch = useDispatch();
    const [document, setDocument] = useState<Document | undefined>(
        props.documents.find((item) => item.type === DocumentsTypes.Regulations),
    );

    useEffect(() => {
        dispatch(requestGetDocumentsList());
    }, []);

    useEffect(() => {
        if (!document) setDocument(props.documents.find((item) => item.type === DocumentsTypes.Regulations));
    }, [props.documents]);

    return (
        <div className="content">
            <Paper className="regulation-text">
                <div
                    dangerouslySetInnerHTML={{
                        __html: document && props.language ? document.text?.[props.language] : '',
                    }}
                ></div>
            </Paper>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        documents: getDocumentsList(state),
    };
}

export default connect(mapStateToProps)(RegulationsPage);
